module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_marco_comida_27.0561dc76.png";